var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2081_159708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 15.0492C4.06413 14.4348 5.27124 14.1113 6.5 14.1113C7.72876 14.1113 8.93587 14.4348 10 15.0492C11.0641 14.4348 12.2712 14.1113 13.5 14.1113C14.7288 14.1113 15.9359 14.4348 17 15.0492",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4.93782C4.06413 4.32344 5.27124 4 6.5 4C7.72876 4 8.93587 4.32344 10 4.93782C11.0641 4.32344 12.2712 4 13.5 4C14.7288 4 15.9359 4.32344 17 4.93782",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4.9375V15.0486",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.9375V15.0486",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4.9375V15.0486",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2081_159708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchProgram);
export default __webpack_public_path__ + "static/media/icon_search_program.6d25339eb2c0da8b7eff9790519827d0.svg";
export { ForwardRef as ReactComponent };